import { render, staticRenderFns } from "./Questionnaires.vue?vue&type=template&id=14ff6f01&"
import script from "./Questionnaires.vue?vue&type=script&lang=ts&"
export * from "./Questionnaires.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol})
